import { API_V1_URL } from './config';
import { defaultAuthedRequest } from './headers';

export async function postChat(
  message: string,
  previous_response_id?: string
): Promise<{ text: string; id: string }> {
  const response = await fetch(`${API_V1_URL}chat`, {
    ...defaultAuthedRequest,
    body: JSON.stringify({ message, previous_response_id }),
  });
  return response.json();
}
